import { some, map } from 'lodash';

import {
  LOGGED_IN_STORAGE_KEY,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  TOKEN_STORAGE_KEY
} from '../actions/auth-actions';

const initialState = {
  loggedIn: !!JSON.parse(localStorage.getItem(LOGGED_IN_STORAGE_KEY)),
  token: localStorage.getItem(TOKEN_STORAGE_KEY)
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return { loggedIn: true, token: action.token };

    case LOGOUT_SUCCESS:
      return { loggedIn: false, token: null };

    default:
      return state;
  }
}

export const pathIsAllowed = (path, state) => {
  const allowedPages = map(
    state.user.allowedPages,
    p => new RegExp(`^${p.replace('*', '.*')}$`)
  );

  const isAllowed = some(allowedPages, p => p.test(path));
  return isAllowed;
};
